import BreakdownPie from "./breakdown-pie";

export default BreakdownPie;